/**
 * Orovia PDP — bind only real visible product pages (never the hidden store)
 */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.ovBindPDP) return;
    const page = document.querySelector('[data-ov-pdp-page-wrap] [data-ov-pdp-page], main [data-ov-pdp-page]');
    if (!page) return;
    if (page.closest('#ov-pdp-store, .ov-pdp-store, [data-ov-pdp-store-item]')) return;
    window.ovBindPDP(page.closest('[data-ov-pdp-page-item]') || page);
  });
})();
